module.exports = __webpack_public_path__ + "img/camps.8c729de2.svg";